import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation } from '@tanstack/react-query';

export const useEhrMutations = () => {
  const { axios } = useNetworkRequest();

  const { mutate: addEHR, isLoading } = useMutation(
    ({ values, assignment_request_id }: { values: number[]; assignment_request_id?: number }) =>
      axios.post('/v3/professional/ehr_systems', {
        assignment_request_id,
        professional_ehr_systems: values,
      }),
  );

  return { addEHR, isLoading };
};
